export const VALID_SUB = /^[a-zA-Z0-9_-]{0,50}$/;
export const ALI_PUB = 'alii.pub';
export const GOT_BY = 'shp.pub';
export const ALLI_PUB = 'alli.pub';
export const aliexpressGoodsRegexp = /\/item\/(-\/)?(?:\d+?[\\-_])?(\d+?)(?:\/-detail)?\.html/u;
export const aliexpressRegexp = /https?:\/\/(?:[^/]+\.)?(?:aliexpress\.(com|ru|us)|ali\.click)/iu;
export const skuIdRegexp = /sku_id=\d+/;
export const ALI_ID = 1;
export const ALI_PUB_DATA = {
    value: ALI_PUB,
    label: ALI_PUB,
};
export const GOT_BY_DATA = {
    value: GOT_BY,
    label: GOT_BY,
};
export const DEFAULT_FILTER_VALUE = {
    offerId: '',
    search: '',
    inputSearch: '',
};

export const ALL_OFFERS = (
    t: (key: string) => string,
): {
    value: number;
    label: string;
} => ({
    value: 0,
    label: t('All offers'),
});

export const MODAL_TYPES = {
    getEridToken: 'getEridToken',
    addPlacement: 'addPlacement',
    selectPlacement: 'selectPlacement',
} as const;
